/**
 * Cookie helper utilities
 */

// The actual cookie name used by @axon-enterprise/i18n-helpers
const LANGUAGE_COOKIE_NAME = 'AL-L';

/**
 * Check if the language cookie has been set by the user
 * Used to determine if we should show the language selector on first load
 * 
 * Note: We check the cookie directly because useLanguageCookie() always returns
 * a default value (en-us), so we can't distinguish between a saved preference
 * and the default fallback.
 * 
 * This is safe for client-side only apps and is better than alternatives because:
 * 1. The hook doesn't expose whether the value is saved or default
 * 2. This check only runs once during initialization
 * 3. No external library needed for a simple cookie check
 */
export const hasLanguageCookie = (): boolean => {
  // Safety check for SSR environments
  if (typeof document === 'undefined') {
    return false;
  }
  
  return document.cookie
    .split(';')
    .some((item) => item.trim().startsWith(`${LANGUAGE_COOKIE_NAME}=`));
};
